import React from 'react';
import { GstManager, GstStateChoice } from '../components/GstManager';

type CustomerGstManagerProps = {
    states: GstStateChoice[];
};

export const CustomerGstManager: React.FC<CustomerGstManagerProps> = ({ states }) => (
    <GstManager states={states} dialogTitle="Manage buyer GST registrations" />
);
